import apiFetch from '../apiFetch'

export default function (token, sectionId) {
  return apiFetch({ endPoint: `Faq/GetAllBySectionId/${sectionId}`, method: 'GET', body: null, token: token })
}
